import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { useGetProfileQuery, Profile } from 'store/profile';

/**
 * APIからプロフィールの状態を取得します
 * @returns {boolean} GETリクエストの成功・失敗を表すブール値
 */
export const useGetProfileData = (): {
  data: Profile | undefined;
  isSuccess: boolean;
  isLoading: boolean;
} => {
  const dispatch = useDispatch();

  // useGetProfileQueryフックを使用してAPIからプロフィールの状態を取得します
  const { data, error, isSuccess, isLoading } = useGetProfileQuery();

  // データの取得結果に応じて処理を行います
  useEffect(() => {
    if (isSuccess && data) {
      console.log('useGetProfileData: success');
    } else if (error) {
      console.log('useGetProfileData: error', error);
    }
  }, [data, dispatch, error, isSuccess]);

  return { data, isSuccess, isLoading };
};
